import { Link } from "react-router-dom";
import Logo from "../../components/Logo/Logo";
import { useTimePeriodContext } from "../../contexts/TimePeriodContext";
import "./ManagerCompleted.css";

function ManagerComplete() {
  const { selectedPeriod } = useTimePeriodContext();

  const gifAmount = 13;

  const randomIndex = Math.floor(Math.random() * gifAmount);
  const gif = `/assets/gifs/completion${randomIndex}.gif`;

  return (
    <>
      <title>Projektkontrolle - Abschluss</title>
      <div className="completed-page">
        <div className="completed-top-section">
          <Logo />
          <div className="completed-text-container">
            <h1 className="completed-title">Projektkontrolle wurde erfolgreich abgeschlossen.</h1>
            <h2 className="completed-subtitle">
              Zeitraum: {selectedPeriod.Month}/{selectedPeriod.Year}
            </h2>
          </div>
        </div>
        <div className="completed-bottom-section">
          <div className="gif-container">
            <img src={gif} alt="Completion GIF" className="completion-gif" />
          </div>
          <Link to="/" className="back-to-home">
            Zurück zur Startseite
          </Link>
        </div>
      </div>
    </>
  );
}

export default ManagerComplete;
